import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ps-ui-linear-gauge-chart',
  templateUrl: './linear-gauge-chart.component.html',
  styleUrls: ['./linear-gauge-chart.component.css'],
})
export class LinearGaugeChartComponent implements OnInit {
  @Input()
  public completes: number;

  @Input()
  public expected: number;

  @Input()
  public goal: number;

  @Input()
  public totalBarSizer: number = 250;

  public greenBarSize = `width: 33px;`;
  public yellowBarSize = `width: 33px;`;
  public redBarSize = `width: 34px;`;
  public arrowPosition = `left: 20px;`;
  public blackBar = 'left: 0px;';
  public componentSize = 'width: 400px';
  public completesColor = 'color: #71ac82;';
  constructor() {}

  ngOnInit(): void {
    if (this.expected > this.goal) {
      this.expected = this.goal;
    }
    const green = this.valueToPixel(this.goal - (this.expected / 100) * 80);
    const yellow =
      this.valueToPixel(this.valueFromPercent(80, this.expected)) -
      this.valueToPixel(this.valueFromPercent(40, this.expected));
    const red = this.valueToPixel(this.valueFromPercent(40, this.expected));
    const arrowPosition = this.goalToPixel() * this.completes;
    const completesColor = this.getCompletesColor(
      this.completes,
      this.expected
    );
    this.completesColor = completesColor;
    this.arrowPosition = `left: ${arrowPosition}px;`; // has to be in actual completes
    this.blackBar = `left: ${this.valueToPixel(this.expected) + 7}px;`;
    this.greenBarSize = `width: ${green}px;`; // 80% of  Expected Complets to Total Survey Goal
    this.yellowBarSize = `width: ${yellow}px;`; // 41 - 80% of Expected Completes
    this.redBarSize = `width: ${red}px;`; // 0 - 40% of the Expected Completes
    this.componentSize = `width: ${this.totalBarSizer}px;`;
  }

  getCompletesColor(completes: number, expected: number) {
    if ((completes * 100) / expected <= 40) {
      return 'color: #ed6a76;';
    } else if (
      (completes * 100) / expected > 40 &&
      (completes * 100) / expected <= 80
    ) {
      return 'color: #eddb53;';
    }
    return 'color: #71ac82;';
  }

  valueFromPercent(percentage: number, of: number) {
    const result = (of / 100) * percentage;
    return result;
  }

  valueToPixel(value: number) {
    const result = this.goalToPixel() * value;
    return result;
  }

  goalToPixel() {
    const result = this.totalBarSizer / this.goal;
    return result;
  }

  public addBarSize() {
    console.log('calculei');
    this.completes += 10;
    this.greenBarSize = `width: ${this.completes}px;`;
  }
}
